import { Component, OnDestroy, OnInit } from '@angular/core';
import { SelectOption, SnackbarService } from '@bcl/design-system';
import { MenuController } from '@ionic/angular';
import { Subject, takeUntil } from 'rxjs';
import { DictionaryService } from 'src/app/services/dictionary.service';
import { BackButtonService } from 'src/app/services/back-button.service';
import { NotesApiService } from 'src/app/shared-components/components/notes-list/notes-api.service';
import {
  NotesList,
  NotesListPageChanged,
  ParentObject,
} from 'src/app/shared-components/components/notes-list/notes.model';

@Component({
  selector: 'app-notes',
  templateUrl: './notes.component.html',
  styleUrls: ['./notes.component.scss'],
})
export class NotesPage implements OnDestroy, OnInit {
  public loading = true;
  public parentObject: ParentObject = 'Users.Users';
  public parentId = 0;
  public notesList: NotesList = { notes: [], totalEntries: 0 };
  public dateFilterOptions: SelectOption[] = [];
  private destroyed$ = new Subject<void>();

  private lastDateFilter = '4';

  constructor(
    private api: NotesApiService,
    private snackbarService: SnackbarService,
    private dictionaryService: DictionaryService,
    private menuCtrl: MenuController,
    private backButtonService: BackButtonService
  ) {}

  public ngOnInit(): void {
    this.getDateFilterOptions();
    this.backButtonService.hideBackButton();
  }

  public ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
  ionViewWillEnter() {
    this.menuCtrl.close();
    this.backButtonService.hideBackButton();
  }

  public loadMoreNotes(page: NotesListPageChanged): void {
    this.lastDateFilter = page.filter.date ?? '0';
    this.getNotes(
      this.lastDateFilter,
      page.pageNumber,
      page.pageSize,
      this.parentObject,
      this.parentId
    );
  }

  public getNotes(
    dateFilterString: string,
    pageNumber: number,
    pageSize: number,
    parentObject: ParentObject,
    parentId: number
  ): void {
    this.api
      .getParentNotes(
        { parentID: parentId, parentObject, dateFilter: dateFilterString },
        pageNumber,
        pageSize
      )
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (result) => {
          this.notesList = result;
        },
        error: () => {
          this.snackbarService.open(
            'red',
            'GENERIC_ERROR_MESSAGES.AN_ERROR_OCCURRED_UNABLE_TO_LOAD_DATA'
          );
        },
      });
  }

  private getDateFilterOptions(): void {
    this.dictionaryService
      .getDateFilters()
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (result) => {
          this.dateFilterOptions = result.map((x) => ({
            value: x.value,
            label: x.name,
          }));
          this.loading = false;
        },
        error: () => {
          this.snackbarService.open(
            'red',
            'GENERIC_ERROR_MESSAGES.AN_ERROR_OCCURRED_UNABLE_TO_LOAD_DATA'
          );
          this.loading = false;
        },
      });
  }
}
